import isEmpty from './TestimonialsIsEmpty'
import Section from './TestimonialsSection'
import Options from './TestimonialsOptions'

export default { isEmpty, Section, Options }
